export const getAudioContext = (() => {
    let ctx: Maybe<AudioContext>;

    return () => {
        if (NODE) {
            return ctx;
        }

        if (!ctx && window.AudioContext) {
            ctx = new AudioContext();
        }

        if (ctx && ctx.state !== 'running') {
            ctx.resume();
        }

        return ctx;
    };
})();
